/** Ícones de traço simples (SVG inline, sem dependência). */
import type { SVGProps } from "react";

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

type P = SVGProps<SVGSVGElement>;

export const IconHome = (p: P) => (
  <svg {...base} {...p}>
    <path d="M3 11 12 4l9 7" />
    <path d="M5 10v10h14V10" />
  </svg>
);
export const IconRunner = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="14" cy="4.5" r="2" />
    <path d="M7 21l3.5-6 3 2.5V22" />
    <path d="M6 12.5 9 9.5h5l2.5 3.5 3 .5" />
    <path d="M10.5 15 13 9.5" />
  </svg>
);
export const IconWhistle = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="14" r="5" />
    <path d="M12.5 10.5 20 6v4l-6 3" />
    <path d="M5 5l2 2" />
  </svg>
);
export const IconGroup = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="8" cy="8" r="3" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M2.5 20c.6-3.4 2.9-5.5 5.5-5.5s4.9 2.1 5.5 5.5" />
    <path d="M14.5 15.2c.8-.5 1.6-.7 2.5-.7 2.2 0 4 1.8 4.5 5" />
  </svg>
);
export const IconShield = (p: P) => (
  <svg {...base} {...p}>
    <path d="M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
export const IconBuilding = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 21V5l8-2v18" />
    <path d="M12 9h8v12" />
    <path d="M7 8h2M7 12h2M7 16h2M15 13h2M15 17h2" />
  </svg>
);
export const IconUser = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c1-4 4-6 8-6s7 2 8 6" />
  </svg>
);
export const IconMenu = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);
export const IconSun = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);
export const IconMoon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z" />
  </svg>
);

export const IconClipboard = (p: P) => (
  <svg {...base} {...p}>
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <path d="M9 4h6v3H9z" />
    <path d="M8.5 12h7M8.5 16h5" />
  </svg>
);
export const IconCalendar = (p: P) => (
  <svg {...base} {...p}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
    <path d="M3.5 10h17M8 3v4M16 3v4" />
  </svg>
);

export const IconPulse = (p: P) => (
  <svg {...base} {...p}>
    <path d="M3 12h4l2.5-6 4 12 2.5-6H21" />
  </svg>
);
export const IconUpload = (p: P) => (
  <svg {...base} {...p}>
    <path d="M12 16V4" />
    <path d="m7 9 5-5 5 5" />
    <path d="M4 16v4h16v-4" />
  </svg>
);

export const IconChart = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 20V10" />
    <path d="M10 20V4" />
    <path d="M16 20v-7" />
    <path d="M22 20H2" />
  </svg>
);
export const IconGauge = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 16a8 8 0 1 1 16 0" />
    <path d="M12 16l4-5" />
  </svg>
);

/** Logotipo horizontal do EAPace (símbolo + nome) para fundos escuros: "EA" em branco, "Pace" em verde. */
export function BrandLogo({ height = 30, className = "" }: { height?: number; className?: string }) {
  return (
    <img
      src="/brand/eapace-lockup-dark.svg"
      alt="EAPace"
      height={height}
      width={Math.round((height * 427) / 96)}
      className={`brand-logo ${className}`}
      decoding="async"
    />
  );
}

export const IconBell = (p: P) => (
  <svg {...base} {...p}>
    <path d="M6 9a6 6 0 1 1 12 0c0 6 2.5 7.5 2.5 7.5h-17S6 15 6 9Z" />
    <path d="M10 20a2 2 0 0 0 4 0" />
  </svg>
);
export const IconChat = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 5h16v11H9l-5 4V5Z" />
    <path d="M8 9.5h8M8 12.5h5" />
  </svg>
);
export const IconScale = (p: P) => (
  <svg {...base} {...p}>
    <rect x="4" y="4" width="16" height="16" rx="3" />
    <path d="M8.5 9a5 5 0 0 1 7 0" />
    <path d="M12 12.5l2-2" />
  </svg>
);
export const IconHelp = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9.5a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1.9-1.1 1.8" />
    <path d="M12 17h.01" />
  </svg>
);
export const IconInbox = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 13l2.5-7h11L20 13v6H4v-6Z" />
    <path d="M4 13h4l1 2h6l1-2h4" />
  </svg>
);

export const IconPaperclip = (p: P) => (
  <svg {...base} {...p}>
    <path d="m21 11-8.6 8.6a5 5 0 0 1-7-7l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-2.9-2.8l8.3-8.3" />
  </svg>
);
export const IconDumbbell = (p: P) => (
  <svg {...base} {...p}>
    <path d="M6.5 6.5v11M17.5 6.5v11M3.5 9v6M20.5 9v6M6.5 12h11" />
  </svg>
);
/** Corrida: figura inclinada para a frente, passada larga e riscos de velocidade. */
export const IconRun = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="15.5" cy="4.5" r="2" />
    <path d="M13 8.5 9.5 12l3 2.5-1.5 6M13 8.5l3.5 2 3-1M9.5 12 6 11.5M12.5 14.5l4 1.5 1.5 3" />
    <path d="M2.5 9h3M1.5 13h2.5" />
  </svg>
);
/** Caminhada: figura ereta, passo curto e bastão de apoio ausente (postura reta distingue da corrida). */
export const IconWalk = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="4" r="2" />
    <path d="M12 7.5v6.5M12 9l-3 4M12 9l3 4M12 14l-2.5 7.5M12 14l3 4v3.5" />
  </svg>
);
/** Esteira: base com rolos, corrimão com painel e uma figura correndo em cima. */
export const IconTreadmill = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="14" cy="4" r="1.8" />
    <path d="M14 7l-2 3.5 2.5 2-1 3M12 10.5 9.5 10M14 8.5l3 1.5" />
    <rect x="3" y="18" width="18" height="3.5" rx="1.75" />
    <path d="M5 18V8l3-2" />
  </svg>
);
/** "Mais": abre as seções que não cabem na barra inferior do celular. */
export const IconMore = (p: P) => (
  <svg {...base} {...p}>
    <circle cx="5" cy="12" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
    <circle cx="19" cy="12" r="1.5" />
  </svg>
);
export const IconEye = (p: P) => (
  <svg {...base} {...p}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
export const IconEyeOff = (p: P) => (
  <svg {...base} {...p}>
    <path d="M10.6 5.1A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a17.6 17.6 0 0 1-2.4 3.4" />
    <path d="M6.6 6.6A17.4 17.4 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.4-1.6" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    <path d="m3 3 18 18" />
  </svg>
);
